module.exports = __webpack_public_path__ + "img/scapp_logo_blk.16e02b41.svg";